import { flow, Instance, types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { BlackPointType } from './models/BlackPointType';

export const BlackPointTypeStore = types
  .compose(
    getBaseStore<Instance<typeof BlackPointType>, Instance<typeof BlackPointType>>(
      BlackPointType,
      'blackPointTypeId',
      'blackPointType',
    ),
    types.model('BlackPointTypeStore', {}),
  )
  .actions((self) => {
    return {
      afterAttach: flow(function*() {
        yield self.loadList();
      }),
    };
  });

export type BlackPointTypeStoreType = Instance<typeof BlackPointTypeStore>;
